export const routeOptions = [
  "alliance_scotland",
  "anglia",
  "central",
  "east_coast",
  "east_midlands",
  "kent",
  "north_east",
  "north_west",
  "sussex",
  "wales",
  "wessex",
  "west_coast",
  "western",
];
